import { ITableModel } from 'components/Table/interface';

const labelOccurrence = {
  label: 'Ocorrência',
  key: 'eventDate',
  size: 150,
  maxSize: 150,
  noFilter: true,
  type: 'date/hour'
};

const labelDescription = {
  label: 'Descrição',
  key: 'description',
  noFilter: true
};

const dataIntegrationModelItems: Array<ITableModel> = [
  labelOccurrence,
  labelDescription
];

const modelDataIntegrationItems = () => {
  const model: Array<ITableModel> = [
    ...dataIntegrationModelItems
  ];

  return model;
};

export {
  modelDataIntegrationItems
};